<template>
    <div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full" :class="{'whitespace-nowrap': textWrap, 'whitespace-normal': !textWrap}">
                <tr class="text-left font-bold">
                    <th 
                        v-for="(header, idx) in headers" 
                        :key="header" 
                        class="px-6 pt-6 pb-4" 
                        v-text="header"
                        :colspan="(idx == headers.length - 1) ? 2 : 1"
                    >
                    </th>
                </tr>
                <slot></slot>
            </table>
        </div>
        <pagination v-if="links" class="my-6" :links="links" />
    </div>
</template>

<script>
import Pagination from '@/Shared/Pagination'

export default {
    components: {
        Pagination,
    },
    props: {
        headers: Array,
        links: Array,
        textWrap: {
            type: Boolean,
            default: false,
        },
    }
}
</script>